module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-shadow-13.cab32e76.png";